<template>
    <!--Client Waiting List Page-->
    <div class="client-step3">
        <!--Step Three-->
        <div class="client-step3-wrap section-wrap">
            <!--Subtitle-->
            <h5>{{ $t("waitingList.title") }} - {{ currentWaitingListStylist.first_name }}, {{
                currentWaitingListStylist.last_name }}</h5>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListClient.stepOne") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListClient.stepTwo") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListClient.stepThree") }}</p>
            </div>
            <p>
                {{ $t("waitingListClient.stepTreeParagraph") }}
            </p>
            <div class="client-step3-wrap" v-show="!loading">
                <div class="select-service-date-wrap">
                    <div class="services-wrap">
                        <div>FROM</div>
                        <div class="service-inner-wrap">
                            <VueDatePicker v-model="selectedDate.from" :format="dateFormat" :type="'date'"
                                placeholder="MM/DD/YYYY" :min-date="today" :auto-apply="true"
                                @update:model-value="handleFromDateChange" />
                            <!-- <div @click="resetCurrentDate('from')" class="close-date">
                                <i class="fa fa-times close-icon" aria-hidden="true"></i>
                            </div> -->
                        </div>
                    </div>
                    <div class="services-wrap">
                        <div>TO</div>
                        <div class="service-inner-wrap">
                            <VueDatePicker v-model="selectedDate.to" :format="dateFormat" placeholder="MM/DD/YYYY"
                                :min-date="minToDate" :max-date="maxToDate" :start-date="startDatepicker2Date"
                                :auto-apply="true" />
                            <!-- <div @click="resetCurrentDate('to')" class="close-date">
                                <i class="fa fa-times close-icon" aria-hidden="true"></i>
                            </div> -->
                        </div>
                    </div>
                </div>
                <p>
                    {{ $t("waitingListClient.stepTreeParagraph2") }}
                </p>
                <p class="text-error" v-if="!selectedDate.from || !selectedDate.to">{{
                    $t("waitingList.note") }} {{ $t("waitingListNotifications.dateRangeMessage") }}</p>
                <div class="next-btn">
                    <button type="button" class="primary-btn extra-small mobile"
                        @click="handleSaveClientWaitlistSettings" :disabled="!selectedDate.from || !selectedDate.to"
                        :class="!selectedDate.from || !selectedDate.to ? 'disabled-button' : ''">
                        {{ $t("general.saveContinue") }}
                    </button>
                    <button type="button" class="secondary-btn small mobile" @click="changeSection('client-step2')">
                        {{ $t("general.goBack") }}
                    </button>
                </div>
                <span class="main-text-link" @click="handleSaveForLater">{{ $t("general.saveLater") }}</span>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import store from "../../../../../services/vuex";
import api from "../../../../../services/apiEndpoints";
import messages from "../../../../../services/messages";
import MainLoader from "../../../general-components/MainLoader.vue";

import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css"; // import the CSS

export default {
    data() {
        return {
            selectedDate: {
                from: null,
                to: null,
            },
            dateFormat: 'MM/dd/yyyy',
            disabledDatesDatepicker2: {
                minDate: null,
                maxDate: null,
            },
            loading: false,
            startDatepicker2Date: null,
            today: new Date(),
        };
    },
    computed: {
        currentWaitingListStylist: {
            get: function () {
                return this.$store.state.currentWaitingListStylist;
            },
            set: function (value) {
                this.$store.commit("setCurrentWaitingListStylist", value);
            },
        },
        maxToDate() {
            if (!this.selectedDate.from) return null;

            const date = new Date(this.selectedDate.from);
            date.setDate(date.getDate() + 30);
            return date;
        },

        minToDate() {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // normalize to midnight

            if (!this.selectedDate.from) {
                // If no FROM selected, default to tomorrow
                const tomorrow = new Date(today);
                tomorrow.setDate(tomorrow.getDate() + 1);
                return tomorrow;
            }

            const fromDate = new Date(this.selectedDate.from);
            fromDate.setHours(0, 0, 0, 0);

            // TO must always be in the future relative to today
            const minDate = new Date(Math.max(fromDate.getTime() + 86400000, today.getTime() + 86400000));
            // 86400000 ms = 1 day

            return minDate;
        },
    },
    mounted() {
        if (this.currentWaitingListStylist.id) {
            this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
        }
    },
    components: {
        VueDatePicker,
        MainLoader,
    },
    methods: {
        changeSection(section) {
            this.$emit('change-section', section);
        },
        resetCurrentDate(type) {
            if (type === 'from') {
                this.selectedDate.from = null;
                this.selectedDate.to = null;
                this.startDatepicker2Date = null;
            } else {
                this.selectedDate.to = null;
            }
        },
        handleSaveClientWaitlistSettings() {
            this.saveClientWaitlistSettings();
            this.changeSection('client-step4');
        },
        saveClientWaitlistSettings() {
            if (!this.selectedDate.from && !this.selectedDate.to) {
                return;
            }

            if (!this.selectedDate.from) {
                return
            }

            if (!this.selectedDate.to) {
                return
            }

            let data = {
                stylist_id: this.currentWaitingListStylist.id,
                from_date: moment(this.selectedDate.from).format('YYYY-MM-DD'),
                to_date: moment(this.selectedDate.to).format('YYYY-MM-DD'),
            };

            this.$http.post(api.actions.save_client_waitlist_settings, data).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                this.getClientWaitlistSettings(this.currentWaitingListStylist.id);

                messages.successMessage(messages.GLOBAL_MESSAGES.WAITING_LIST_DATE_RANGE);
            });
            return;
        },
        getClientWaitlistSettings(stylistId) {
            this.loading = true;
            this.$http.get(api.actions.get_client_waitlist_settings + "/" + stylistId).then((response) => {
                const settings = response.data.settings;

                // Better validation for SQL 'empty' dates
                const isValidFrom = settings.from_date && settings.from_date !== '0000-00-00';
                const isValidTo = settings.to_date && settings.to_date !== '0000-00-00';

                if (isValidFrom && isValidTo) {
                    // Use moment to parse to avoid timezone shifting
                    this.selectedDate.from = moment(settings.from_date).toDate();
                    this.selectedDate.to = moment(settings.to_date).toDate();
                    this.startDatepicker2Date = this.selectedDate.from;
                }
                this.loading = false;
            }).catch(() => { this.loading = false; });
        },
        onFromDateChange(date) {
            // Use a simple truthy check
            if (!date) {
                this.selectedDate.to = null;
                return;
            }

            this.startDatepicker2Date = date;

            // If "To" date is now out of bounds (before From or after 30 days), reset it
            if (this.selectedDate.to) {
                const end = moment(this.selectedDate.to);
                const start = moment(date);
                const diff = end.diff(start, 'days');

                if (diff < 0 || diff > 30) {
                    this.selectedDate.to = null;
                }
            }
        },
        compareDates() {
            if (this.selectedDate.from && this.selectedDate.to) {
                const start = new Date(this.selectedDate.from);
                const end = new Date(this.selectedDate.to);

                // Compare the two dates
                if (end.getTime() > start.getTime()) {
                    this.selectedDate.to = ""; // Returns true if the end date is after the start date
                }
            }
        },
        limitFutureDays(startDate, days) {
            const date = new Date(startDate);

            date.setDate(date.getDate() + days);

            this.disabledDatesDatepicker2.from = date;
            this.disabledDatesDatepicker2.to = startDate;

            return date;
        },
        handleSaveForLater() {
            if (!this.selectedDate.from || !this.selectedDate.to) {
                return
            }

            this.saveClientWaitlistSettings();
            this.changeSection('client-wlist');
        },
        handleFromDateChange(date) {
            if (!date) return;

            this.startDatepicker2Date = date;

            // Reset TO if it's now invalid
            if (this.selectedDate.to) {
                const toDate = new Date(this.selectedDate.to);
                if (toDate < this.minToDate) {
                    this.selectedDate.to = null;
                }
            }
        },
    },
};
</script>
